import { useSelector } from 'react-redux';
import { selectPendingSessions } from 'services/pendingSessions/pendingSessions.selectors';
import SessionCard from '../SessionCard/SessionCard.component';
import { PendingSessionsListContainer } from './style/PendingSessionsList.style';

export default function PendingSessionsList() {
  const pendingSessions = useSelector(selectPendingSessions);

  if (!pendingSessions.sessionsList?.length) return null;

  return (
    <PendingSessionsListContainer>
      {pendingSessions.sessionsList.map((session) => (
        <SessionCard
          key={session.gameId}
          gameId={session.gameId}
          gameType={session.gameType}
          gameDescription={session.gameDescription}
          sessionBalance={session.sessionBalance}
          token={pendingSessions.token}
        />
      ))}
    </PendingSessionsListContainer>
  );
}
